(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .factory("checkoutService", ["$localStorage", checkoutService]);
    function checkoutService($localStorage) {
        var checkoutServiceFactory = {
            wizard: {
                step: 1
            },
            model: {}
        };
        function start() {
            if ($localStorage.checkoutData) {
                checkoutServiceFactory.wizard = angular.copy($localStorage.checkoutData.wizard);
                checkoutServiceFactory.model = angular.copy($localStorage.checkoutData.model);
                delete $localStorage.checkoutData;
            }
            else {
                checkoutServiceFactory.wizard.step = 1;
                checkoutServiceFactory.model = {};
                delete checkoutServiceFactory.wizard.isStep1Valid;
                delete checkoutServiceFactory.wizard.isStep2Valid;
                delete checkoutServiceFactory.wizard.isStep3Valid;
                delete checkoutServiceFactory.wizard.isStep4Valid;
            }
        }
        function setStep(step) {
            checkoutServiceFactory.wizard.step = step;
        }
        function save() {
            $localStorage.checkoutData = {
                wizard: angular.copy(checkoutServiceFactory.wizard),
                model: angular.copy(checkoutServiceFactory.model),
            };
        }
        checkoutServiceFactory.start = start;
        checkoutServiceFactory.setStep = setStep;
        checkoutServiceFactory.save = save;
        return checkoutServiceFactory;
    }
}());
